import { useBareAssetAggregate } from '../contexts';
import { useCardAppearanceFragment } from '../gql/generated/CardAppearance';

/**
 * The useCardAppearance hook returns the values for the CardAppearance fragment
 * for the current AssetAggregate.
 */
export function useCardAppearance() {
  const from = useBareAssetAggregate() ?? {};

  return useCardAppearanceFragment({
    from,
  }).data?.appearance;
}
